import { render } from "./nonacademicAssessorSection2.vue?vue&type=template&id=3660fe91"
import script from "./nonacademicAssessorSection2.vue?vue&type=script&lang=js"
export * from "./nonacademicAssessorSection2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__